import { useEffect, useState } from "react";
import { Transition } from "@headlessui/react";
import { userService } from "../../services/user.service";
import Alert from "../Alert";
import SuccessAlert from "../SuccessAlert";

export default function ForgotPasswordModal(props) {
  const [open, setOpen] = useState(false);
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState("");
  const [processing, setProcessing] = useState(false);
  const [success, setSuccess] = useState("");

  const handleClose = () => {
    props.setOpen(false);
    //setOpen(false);
  };

  const handleChange = (e) =>
    setInputs((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

  const forgotPasswordClick = async (e) => {
    setError("");
    setSuccess(false);
    setProcessing(true);
    const result = await userService.sendPasswordReset(inputs.email);

    if (result.status === 400) {
      setError(result.data.details[0].details);
    } else if (result.status === 500) {
      setError("Unknown Error Occurred")
    } else {
      setSuccess(true);
    }
    setProcessing(false);
  };

  useEffect(() => {
    setSuccess(false);
    setOpen(props.open);
  }, [, props.open]);

  return (
    <Transition
      show={open}
      enter="transition-opacity duration-500"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-500"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
        <div className="relative my-6 mx-auto w-auto max-w-sm">
          {/*content*/}
          <div className="relative flex w-full flex-col rounded-lg border-0 bg-white shadow-lg outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between rounded-t border-b border-solid border-slate-200 p-5">
              <h3 className="text-xl font-semibold">Forgot Password</h3>
              <button
                className="float-right ml-auto border-0 bg-transparent p-1 text-3xl font-semibold leading-none text-black opacity-5 outline-none focus:outline-none"
                onClick={handleClose}
              >
                <span className="block h-6 w-6 bg-transparent text-2xl text-black opacity-5 outline-none focus:outline-none">
                  ×
                </span>
              </button>
            </div>
            {/*body*/}
            <div className="relative flex-auto p-6">
              <div className="pb-5">
                Enter your email address below to receive a temporary password
              </div>
              <div className="mb-2 flex flex-col">
                <div className="relative flex ">
                  <input
                    onChange={handleChange}
                    type="input"
                    name="email"
                    id="email"
                    className="w-full flex-1 appearance-none rounded-lg border border-gray-300 bg-white py-2 px-4 text-base text-gray-700 placeholder-gray-400 shadow-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-purple-600"
                    placeholder="Email Address"
                  />
                </div>
              </div>
              {error && (
                <div
                  className="border-l-4 border-red-600 bg-red-200 p-4 text-red-600"
                  role="alert"
                >
                  <p>{error}</p>
                </div>
              )}
              {success && <SuccessAlert message="New password has been sent to your email"/>}
            </div>
            {/*footer*/}
            <div className="flex items-center justify-end rounded-b border-t border-solid border-slate-200 p-6">
              <button
                className="background-transparent mr-1 mb-1 px-6 py-2 text-sm font-bold uppercase text-red-500 outline-none transition-all duration-150 ease-linear focus:outline-none"
                type="button"
                onClick={handleClose}
              >
                Close
              </button>
              <button
                onClick={forgotPasswordClick}
                type="button"
                className="ico flex items-center rounded-lg bg-emerald-700 px-10 py-2 text-center text-center text-white hover:cursor-pointer hover:bg-emerald-600 disabled:bg-gray-600"
                disabled={processing}
              >
                {processing && (
                  <svg
                    className="mr-3 h-5 w-5 animate-spin text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                )}
                <span className="mx-auto text-center font-normal">
                {processing ? "Working..." : "Send Reset"}
              </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
    </Transition>
  );
}
